import type { StayCelebrationType } from "./stayData"

export type CelebrationTypeOption = {
  label: string
  value: StayCelebrationType
}

export const celebrationTypeOptions = [
  { label: "Birthday", value: "birthday" },
  { label: "Anniversary", value: "anniversary" },
  { label: "Honeymoon", value: "honeymoon" },
  { label: "Celebration", value: "celebration" },
  { label: "Other", value: "other" },
] satisfies readonly CelebrationTypeOption[]
